import React from 'react';
import '../../styles/ChatMenu.css';

/** "apply_layout_option" → "Apply layout option". */
const titleOf = (name) =>
  name.charAt(0).toUpperCase() + name.slice(1).replace(/_/g, ' ');

/** A description's first sentence: what the call does, without the detail. */
const firstSentence = (text) => {
  const match = /^.*?[.!?](?=\s|$)/s.exec(text ?? '');
  return match ? match[0] : text;
};

/**
 * Allow / Deny before a browser-run chat turn runs a call that asks first
 * (an app action marked `confirm`, or a server tool that deletes or
 * replaces): what it is, what it does and what it was given.
 */
const ChatConfirmCard = ({ call, description, onAllow, onDeny }) => {
  const hasInput = call.input && Object.keys(call.input).length > 0;
  return (
    <div className="chat-confirm-card" role="group" aria-label="Confirm">
      <div className="chat-confirm-title">{titleOf(call.name)}</div>
      {description && (
        <div className="chat-confirm-description">
          {firstSentence(description)}
        </div>
      )}
      {hasInput && (
        <pre className="chat-confirm-input">
          {JSON.stringify(call.input, null, 2)}
        </pre>
      )}
      <div className="chat-confirm-buttons">
        <button type="button" className="chat-confirm-deny" onClick={onDeny}>
          Deny
        </button>
        <button type="button" className="chat-confirm-allow" onClick={onAllow}>
          Allow
        </button>
      </div>
    </div>
  );
};

export default ChatConfirmCard;
